<template>
    <van-popup v-model="isMSpec" position="bottom" class="isMSpec-pop" @closed="closePopup">
      <ul class="list-item">
        <li v-for="(item, index) in goodsList" :key="index" :class="`item${index}`" :id="`item${index}`" >
          <div v-show="!isOver && !isYlxdsqApp" class="detail_price">
            <div v-if="item.storage > 0">
              <div class="van-stepper" v-if="activityFlag != 1">
                <!-- <button type="button" class="van-stepper__minus" v-if="item.number > 0" @click="reduceClick(index)"></button> -->
                <template v-if="goodsList.length > 1">
                  <van-image fit="widthFix" width="24px" height="24px" lazy-load @click="reduceClick(item)" v-if="item.number > 0" src="https://i0.ulecdn.com/mini/ylsq/images/solitaire_icon_down.png" />
                </template>
                <template v-else-if="goodsList.length ==1">
                  <van-image fit="widthFix" width="24px" height="24px" lazy-load @click="reduceClick(item)" v-if="item.number > 1" src="https://i0.ulecdn.com/mini/ylsq/images/solitaire_icon_down.png" />
                  <van-image fit="widthFix" width="24px" height="24px" lazy-load  v-if="item.number == 1" src="https://i0.ulecdn.com/mini/ylsq/images/solitaire_icon_down_dis.png"/>
                </template>
                <van-field v-model="item.number" type="digit" v-if="item.number > 0" @blur="goodsNum(item)" @input="formatter(index)" input-align="center" class="van-stepper__input"/>
                <!-- <button type="button" class="van-stepper__plus" @click="plusClick(index)"></button> -->
                <van-image fit="widthFix" width="24px" height="24px" lazy-load @click="plusClick(item)" v-if="isBegin" src="https://i0.ulecdn.com/mini/ylsq/images/solitaire_icon_up.png" />
              </div>
              <div v-else class="van-stepper">
                <van-field v-model="item.number = item.limitNum * setMealNum" v-show="item.number > 0" disabled type="digit" input-align="center" class="van-setMealNum_input" />
              </div>
            </div>
            <div v-else class="saled">已售罄</div>
          </div>
          <div class="left-img">
            <van-image :src="item.imgUrl" lazy-load contain />
          </div>
          <div class="right-lay">
            <p class="right-lay-top van-multi-ellipsis--l2">{{ item.colorName }} &nbsp; {{ item.specificationName }}</p>
            <!-- <p class="saled">
              已售
              {{ item.totalSold || 0 }}份
            </p> -->
            <div class="right-lay-bottom">
              <span class="left-price">
                <template v-if="activityFlag != 1">{{ item.salPrice | currency }}</template>
                <template v-if="isYlxdsqApp">
                  <!-- 试点 -->
                  <span class="commission_ico" v-if="isPilot && item.saleCommission > 0">成单赚¥{{ item.saleCommission }}</span>
                  <!-- 非试点 -->
                  <span class="commission_ico" v-if="!isPilot && item.yzgRealCommission > 0">成单赚¥{{ item.yzgRealCommission }}</span>
                </template>
              </span>
            </div>
          </div>
        </li>
      </ul>    
      <div class="specBtnCon">
        <div class="cancel" @click="specCancel">取消</div>
        <div class="confirm" @click="specConfirm">确认加购</div>
      </div>  
    </van-popup>    
</template>
<script>
export default {
    name: "moreSpec",
    props: {
        moreSpecGoods: {
            type: Array,
            default: () => [],
        },
        isOver: {
            type: Boolean,
            default: false,
        },
        activityFlag: {
            // type: Number,
            default: '',
        },
        isYlxdsqApp: {
            type: Boolean,
            default: true,
        },
        isBegin: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            isMSpec:true,
            goodsList:[]
        };
    },
    mounted() {
      this.goodsList = JSON.parse(JSON.stringify(this.moreSpecGoods));
    },
    methods: {
      // 加号
      plusClick(item) {
        if (item.number < item.limitNum) {
          item.number = item.limitNum;
        } else item.number++;
      },        
      // 减号
      reduceClick(item) {
        if (item.number <= 0) {
          return;
        } else {
          if (item.number <= item.limitNum) {
            item.number = 0;
          } else item.number--;
        }
      },
      // 失去焦点
      goodsNum(item) {
        console.log("item", item);
        if (item.number > 0 && item.number < item.limitNum) {
          item.number = item.limitNum;
        }
      },
      // 输入过滤
      formatter(index) {
        let number = this.goodsList[index].number;
        if (number === "") {
          this.goodsList[index].number = 0;
        } else {
          // 第一位输入0
          if (number.indexOf(0) === 0) {
            console.log("number", number);
            this.goodsList[index].number = number.replace(/0/g, "");
          }
        }
      },  
      specConfirm(){
        this.$emit('specConfirm',this.goodsList)
      },
      specCancel(){
        this.isMSpec = false
      },
      closePopup(){
        this.$emit('specConfirm',null)
      }    
    },
};
</script>
<style lang="scss" scoped>
.isMSpec-pop{
  width: 100%;
  max-height: 70%;
  background: #fff;
  padding-bottom: 50px;
  box-sizing: border-box;
  .list-item {
    background: #fff;
    border-radius: 15px;
    padding: 0 15px;
    margin-bottom: 5px;
    overflow: hidden;

    li {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding: 10px 0;
      overflow: hidden;
      position: relative;

      .detail_price {
        position: absolute;
        right: 0;
        bottom: 15%;
        z-index: 10;

        .van-stepper__input {
          display: inline-block;
          margin: 0 10px;
          border-radius: 12px;
          width: 40px;
        }

        .van-setMealNum_input {
          position: relative;
          display: inline-block;
          margin: 0 10px;
          border-radius: 12px;
          width: 60px;
          padding: 0 0 0 20px;
          box-sizing: border-box;

          &::after {
            content: "x";
            position: absolute;
            height: 100%;
            left: 12px;
            top: -1px;
          }

          ::v-deep.van-field__control:disabled {
            color: #323233;
          }
        }

        .van-stepper {
          justify-content: flex-start;
          align-items: center;
          display: flex;

          .van-stepper__plus,
          .van-stepper__minus {
            background-image: linear-gradient(to bottom, #fe8062, #fe3d6e);
            border-radius: 50%;

            &::after,
            &::before {
              color: #fff;
            }
          }
        }
      }

      .left-img {
        width: 70px;
        height: 70px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;

        img {
          width: 100%;
          height: 100%;
          display: block;
        }
      }

      .right-lay {
        flex: 1;
        margin-left: 15px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-direction: column;

        .saled {
          color: #666;
          width: 100%;
          margin-top: 5px;
        }

        &-top {
          width: 100%;
          min-height: 45px;
          font-size: 16px;
        }

        &-bottom {
          margin-top: 10px;
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 30px;

          .left-price {
            color: #ef3b39;
            font-size: 16px;
            font-weight: 700;
            line-height: 24px;
          }

          .commission_ico {
            padding: 4px 6px;
            background: linear-gradient(90deg, #ff8345 0%, #ff2929 100%);
            border-radius: 10px 10px 10px 2px;
            font-size: 11px;
            font-weight: 500;
            color: #ffffff;
            line-height: 22px;
            margin-left: 6px;
          }

          >div {
            z-index: 1;
          }
        }
      }
    }
  }  
  .specBtnCon{
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    background: #fff;
    z-index: 11;
    .cancel{
      width: 25%;
      height: 40px;
      line-height: 40px;
      border-radius: 40px;
      text-align: center;
      color: #fff;
      background: #dddddd;
      border-color: #dddddd;
    }
    .confirm{
      width: 65%;
      height: 40px;
      line-height: 40px;
      border-radius: 40px;
      text-align: center;
      color: #fff;
      background: linear-gradient(to right, #ff8b33, #ff1b2d);
    }
  }
}
</style>